import type { Breakpoint } from "@mui/material";
import type { CSSProperties } from "react";

export const defaultChartResponsiveHeights = {
	xxl: "300px",
	xl: "250px",
	lg: "200px",
	xs: "150px",
} as const satisfies Partial<Record<Breakpoint, CSSProperties["height"]>>;

export const defaultChartResponsiveWidths = {
	xxl: "550px",
	xl: "430px",
	lg: "300px",
	xs: "200px",
} as const satisfies Partial<Record<Breakpoint, CSSProperties["height"]>>;
